module.exports = __webpack_public_path__ + "static/IFDI_Summerbuy-427274e2be5c823bfd82fee5db9a6990.jpeg";